import { baseApi } from './baseApi';

interface Product {
  id: string;
  title: string;
  slug: string;
  description: string;
  price: number;
  images: string[];
  categoryId: string;
  sellerId: string;
  status: string;
  stock: number;
  tags: string[];
  rating: number;
  reviewCount: number;
  createdAt: string;
  updatedAt: string;
}

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

interface ProductsQueryParams {
  page?: number;
  limit?: number;
  category?: string;
  search?: string;
}

export const productsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query<
      { success: boolean; data: PaginatedResponse<Product> },
      ProductsQueryParams | void
    >({
      query: (params) => ({
        url: '/products',
        params: params || {},
      }),
      providesTags: ['Products'],
    }),

    getProduct: builder.query<Product, string>({
      query: (idOrSlug) => `/products/${idOrSlug}`,
      transformResponse: (response: { success: boolean; data: Product }) =>
        response.data,
      providesTags: (_result, _error, id) => [{ type: 'Products', id }],
    }),

    getProductBySlug: builder.query<Product, string>({
      query: (slug) => `/products/slug/${slug}`,
      transformResponse: (response: { success: boolean; data: Product }) =>
        response.data,
      providesTags: (_result, _error, slug) => [{ type: 'Products', id: slug }],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductQuery,
  useGetProductBySlugQuery,
} = productsApi;
